/**
 * Failure channel between the runtime and its host app.
 *
 * The runtime has no UI, so a failing node can only reach the user if the host
 * (viewer) registers a reporter. Without one, failures stay console-only - which
 * is exactly how broken graphs used to look like "nothing happens".
 */
let reportToHost = null;
/** Host apps register here to turn graph failures into user-visible feedback. */
export function setGraphErrorReporter(reporter) {
    reportToHost = reporter;
}
export function reportGraphError(report) {
    logGraphError(report);
    if (!reportToHost)
        return;
    try {
        reportToHost(report);
    }
    catch (reporterError) {
        console.error('[graph] error reporter threw and was ignored', reporterError);
    }
}
/** Best-effort message for arbitrary thrown values. */
export function toErrorMessage(error) {
    if (error instanceof Error)
        return error.message;
    if (typeof error === 'string')
        return error;
    if (error === undefined || error === null)
        return 'Unknown error';
    return String(error);
}
function logGraphError(report) {
    const prefix = `[graph] ${report.kind} ${report.nodeType} (${report.nodeId}): ${report.summary}`;
    if (report.error === undefined) {
        console.error(prefix);
        return;
    }
    console.error(prefix, report.error);
}
/**
 * Attaches a failure handler to a node `run()` result without awaiting it.
 * `run()` is typed `void | Promise<void>`, so async overrides would otherwise
 * turn a throw into an unhandled rejection.
 */
export function catchAsyncFailure(result, onFailure) {
    if (!(result instanceof Promise))
        return;
    result.catch(onFailure);
}
